<script lang="ts">
  import CmsImage from '$components/cms-image.svelte';
  import SectionTitle from '$components/section-title.svelte';
  import { button } from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { GameStoryblokWithGame } from '$types/game';
  import Game from './game.svelte';
  import { portal } from '$lib/actions/portal';
  import { escapeKey } from '$lib/actions/escape-key';
  import { fade } from 'svelte/transition';
  import { onMount } from 'svelte';
  import { zoomOnScrollHandler } from '$lib/transitions';
  import { reducedMotion } from '@significa/svelte-toaster';

  export let block: GameStoryblokWithGame;
  export let showInProductsGrid: boolean | undefined = undefined;

  onMount(() => {
    if (block.slight_zoom_on_scroll && !$reducedMotion) {
      const handler = () => {
        zoomOnScrollHandler(imageContainer, (n) => (scale = n));
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  });

  let imageContainer: HTMLElement;
  let scale = 1;

  let isPlaying = false;

  const closeGame = () => {
    isPlaying = false;
  };

  // TODO: If we are playing we should not allow to scroll the body
</script>

<section
  class={cn(
    !showInProductsGrid && 'px-2 pt-16 pb-2 lg:pt-[72px] lg:pb-8 lg:px-8',
    showInProductsGrid && 'h-full'
  )}
  style:--scale={scale}
>
  <div
    class={cn('container isolate mx-auto', showInProductsGrid && 'h-full')}
    use:storyblokEditable={block}
  >
    {#if !showInProductsGrid && block.title && block.title.length > 0}
      <SectionTitle block={block.title[0]} />
    {/if}

    <button
      name="Play game"
      class={cn(
        'relative w-full flex grow items-end p-4 overflow-hidden rounded-md',
        !showInProductsGrid ? 'h-[560px]' : 'h-full'
      )}
      on:click={() => (isPlaying = true)}
      bind:this={imageContainer}
    >
      <CmsImage
        image={block.image}
        options={{ size: [1440, 0] }}
        class="hidden lg:block absolute scale-[var(--scale)] inset-0 -z-10 h-full w-full rounded-md object-cover"
      />
      <CmsImage
        image={block.mobile_image}
        options={{ size: [1000, 0] }}
        class="block lg:hidden absolute scale-[var(--scale)] inset-0 -z-10 h-full w-full rounded-md object-cover"
      />
      <div
        class={cn(button({ variant: 'secondary', size: 'md' }), 'w-full backdrop-blur lg:w-fit')}
      >
        {block.cta}
      </div>
    </button>

    <!-- TODO: Role should be button -->
    {#if isPlaying}
      <div
        use:portal
        use:escapeKey={{ id: 'game', callback: () => (isPlaying = false) }}
        on:click|self={() => {
          isPlaying = false;
        }}
        transition:fade|global={{ duration: 200 }}
        role="none"
        class="fixed bg-primary/40 z-50 w-screen h-screen screen inset-0 px-2 py-4"
      >
        <div
          class="absolute top-0 left-0 h-screen w-screen"
          role="none"
          on:click={() => {
            isPlaying = false;
          }}
        />
        <div
          class="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] rounded-md overflow-hidden m-auto inline"
        >
          <Game gameStory={block.game} {closeGame} />
        </div>
      </div>
    {/if}
  </div>
</section>
